import styled from 'styled-components';
import Icon from 'components/Icon';
import { spin } from 'styles/animations';

/**
 * A spinning dot to be used as a loading indicator
 */

var SpinnerDot = styled(Icon).attrs({
  name: 'spinnerdot'
}).withConfig({
  displayName: "SpinnerDot",
  componentId: "sc-pb4n09-0"
})(["animation:", " 0.6s infinite linear both;"], spin);
export default SpinnerDot;